export default __webpack_public_path__ + "static/media/guest_20_01.26250263.png";